import React, { type FC } from 'react'
import { SvgIcon, type SvgIconProps } from '@mui/material'

export const SidePanelCloseIcon: FC<SvgIconProps> = (props) => (
    <SvgIcon data-testid="SidePanelCloseIcon" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <g id="icon/side-panel/close">
            <path
                id="Vector (Stroke)"
                d="M20.2998 5C20.2998 4.28203 19.718 3.7002 19 3.7002H15.7002V20.2998H19C19.718 20.2998 20.2998 19.718 20.2998 19V5ZM9.50488 8.50488C9.77825 8.23152 10.2218 8.23152 10.4951 8.50488C10.7685 8.77825 10.7685 9.22175 10.4951 9.49512L7.99023 12L10.4951 14.5049C10.7685 14.7782 10.7685 15.2218 10.4951 15.4951C10.2218 15.7685 9.77825 15.7685 9.50488 15.4951L6.50488 12.4951C6.23152 12.2218 6.23152 11.7782 6.50488 11.5049L9.50488 8.50488ZM3.7002 19C3.7002 19.718 4.28203 20.2998 5 20.2998H14.2998V3.7002H5C4.28203 3.7002 3.7002 4.28203 3.7002 5V19ZM21.7002 19C21.7002 20.4912 20.4912 21.7002 19 21.7002H5C3.50883 21.7002 2.2998 20.4912 2.2998 19V5C2.2998 3.50883 3.50883 2.2998 5 2.2998H19C20.4912 2.2998 21.7002 3.50883 21.7002 5V19Z"
                fill="currentColor"
            ></path>
        </g>
    </SvgIcon>
)
